import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/login page/Login';
import ProfilePage from './pages/mondoub pages/profile page/ProfilePage';
import SignUp from './pages/sign up page/SignUp';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './configs/theme';
import "./responsive1200.css";
import "./reponsive760.css";
import "./responsive600.css";
import "./responsive300.css";
import { useFetchData } from './hooks/useFetchData';
import { useAuthContext } from './hooks/useAuthContext';
import { useEffect } from 'react';

function App() {
  const { data, loading, error } = useFetchData("mandoub/checkauth");
  const { dispatch, auth } = useAuthContext();

  useEffect(() => {
    if (data && data.user && data.user.fullName) {
      dispatch({ type: "LOGIN", payload: data });
    }
  }, [data, dispatch]); // Proper dependency array

  if (loading) {
    return <div>Loading...</div>;
  }

 



    return (
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route path="/*" element={auth?.token? <ProfilePage /> : <Navigate to="/login" />} />
            <Route 
              path="/login" 
              element={!auth?.token? <Login /> : <Navigate to="/" />} 
            />
            <Route 
              path="/signup" 
              element={!auth?.token? <SignUp /> : <Navigate to="/" />} 
              />
            {/* <Route path="*" element={<Navigate to="/profile" replace />} /> */}
          </Routes>
        </Router>
      </ThemeProvider>
    ); 
}


export default App;
